export const shimmerDataLocators = {
    shimmer_row_container_test_id: 'shimmer-row'
};
